import React, { useState, useEffect, useCallback } from 'react';
import axiosInstance from '../api/axiosConfig';

function ProspectsClientsPage() {
  const [prospects, setProspects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [processingId, setProcessingId] = useState(null);
  const [error, setError] = useState('');

  const fetchProspects = useCallback(async () => {
    setIsLoading(true);
    setError('');
    try {
      const response = await axiosInstance.get('/admin/clients/prospects-en-attente');
      setProspects(response.data);
    } catch (err) {
      console.error('Erreur chargement prospects:', err);
      setError("Impossible de charger la liste des clients en attente.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProspects();
  }, [fetchProspects]);

  const handleValider = async (client) => {
    if (!window.confirm(`Valider "${client.nom_client}" comme client officiel ?`)) return;
    setProcessingId(client.id);
    try {
      await axiosInstance.put(`/admin/clients/${client.id}/valider-prospect`);
      setProspects(prev => prev.filter(c => c.id !== client.id));
    } catch (err) {
      console.error('Erreur validation prospect:', err);
      alert("Erreur lors de la validation.");
    } finally {
      setProcessingId(null);
    }
  };

  const handleRejeter = async (client) => {
    if (!window.confirm(`Rejeter et supprimer définitivement "${client.nom_client}" ?\n\nCette action est irréversible.`)) return;
    setProcessingId(client.id);
    try {
      await axiosInstance.delete(`/admin/clients/${client.id}`);
      setProspects(prev => prev.filter(c => c.id !== client.id));
    } catch (err) {
      console.error('Erreur rejet prospect:', err);
      alert("Erreur lors du rejet.");
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Clients à prospecter en attente de validation</h2>
      <p style={{ color: '#666' }}>
        Clients créés sur le terrain via l'application de géolocalisation. Ils ne sont pas encore
        utilisables (pas de visite possible) tant qu'ils ne sont pas validés ici.
      </p>

      {isLoading ? (
        <div>Chargement...</div>
      ) : error ? (
        <div style={{ color: '#dc3545' }}>{error}</div>
      ) : prospects.length === 0 ? (
        <div>Aucun client en attente de validation.</div>
      ) : (
        <div style={{ display: 'grid', gap: '15px', marginTop: '20px' }}>
          {prospects.map(client => (
            <div key={client.id} style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '15px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              flexWrap: 'wrap',
              gap: '10px'
            }}>
              <div>
                <div style={{ fontWeight: '600', fontSize: '16px', marginBottom: '6px' }}>
                  {client.nom_client}
                </div>
                <div style={{ fontSize: '13px', color: '#555', display: 'grid', gap: '3px' }}>
                  {client.contact && <div>📞 {client.contact}</div>}
                  {client.typologie && <div>🏬 Typologie : {client.typologie}</div>}
                  {client.zone && <div>📍 Zone : {client.zone}</div>}
                  {client.lieu_dit && <div>🗺️ Lieu-dit : {client.lieu_dit}</div>}
                  {client.localisation && <div>Localisation : {client.localisation}</div>}
                  <div>📋 Type : {client.type_client}{client.client_direct_nom ? ` (${client.client_direct_nom})` : ''}</div>
                  {client.latitude && client.longitude ? (
                    <div>
                      🛰️ GPS : {client.latitude.toFixed(5)}, {client.longitude.toFixed(5)}{' '}
                      <a
                        href={`https://www.google.com/maps?q=${client.latitude},${client.longitude}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        (voir sur la carte)
                      </a>
                    </div>
                  ) : (
                    <div style={{ color: '#dc3545' }}>⚠️ Pas encore géolocalisé</div>
                  )}
                  {client.merchandiser_nom && <div>👤 Créé par : {client.merchandiser_nom}</div>}
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => handleValider(client)}
                  disabled={processingId === client.id}
                  style={{ background: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', padding: '8px 14px', cursor: 'pointer' }}
                >
                  ✅ Valider
                </button>
                <button
                  onClick={() => handleRejeter(client)}
                  disabled={processingId === client.id}
                  style={{ background: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', padding: '8px 14px', cursor: 'pointer' }}
                >
                  ❌ Rejeter
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProspectsClientsPage;
